import { Controller } from "@hotwired/stimulus";

// Combines the search box and the "Todas / Grupo X" chips on the Equipes
// page: filters team cards by name and by group, hiding any group section
// left with no visible cards so the page doesn't show empty headers.
export default class extends Controller {
  static targets = ["search", "chip", "group", "card", "empty"];

  connect() {
    this.selectedGroup = "all";
    if (this.chipTargets.length) this.setActiveChip(this.chipTargets[0]);
    this.apply();
  }

  selectGroup(event) {
    this.selectedGroup = event.currentTarget.dataset.group;
    this.setActiveChip(event.currentTarget);
    this.apply();
  }

  apply() {
    const query = this.searchTarget.value.trim().toLowerCase();
    const groupHasVisible = {};

    this.cardTargets.forEach((card) => {
      const matchesGroup = this.selectedGroup === "all" || card.dataset.group === this.selectedGroup;
      const matchesQuery = card.dataset.name.includes(query);
      const visible = matchesGroup && matchesQuery;
      card.classList.toggle("hidden", !visible);
      if (visible) groupHasVisible[card.dataset.group] = true;
    });

    let anyVisible = false;
    this.groupTargets.forEach((group) => {
      const visible = !!groupHasVisible[group.dataset.group];
      group.classList.toggle("hidden", !visible);
      if (visible) anyVisible = true;
    });

    this.emptyTarget.classList.toggle("hidden", anyVisible);
  }

  setActiveChip(chip) {
    this.chipTargets.forEach((c) => {
      const active = c === chip;
      c.classList.toggle("bg-amber-500", active);
      c.classList.toggle("border-amber-500", active);
      c.classList.toggle("text-neutral-950", active);
      c.classList.toggle("bg-white", !active);
      c.classList.toggle("text-neutral-600", !active);
    });
  }
}
